import { useState, useEffect } from "react";

import Switch from "@mui/material/Switch";
import { styled } from "@mui/material/styles";
import { typeInfo } from "../../../../../constants/typeInfo";

const CustomSwitch = styled(Switch)(({ theme }) => ({
  width: 90, // 전체 Switch 크기 조정
  height: 54,
  padding: 10,
  "& .MuiSwitch-switchBase": {
    "&.Mui-checked": {
      transform: "translateX(42px)", // 스위치 이동 거리 조정
    },
  },
  "& .MuiSwitch-track": {
    backgroundColor: "#bdbdbd", // 기본 배경색
    borderRadius: 20,
  },
}));

const UnknownSwitch = ({ initChecked, onChange }) => {
  const [checked, setChecked] = useState(initChecked); // 초기값을 false로 설정

  const handleChange = (event) => {
    onChange(event.target.checked);
    setChecked(event.target.checked);
  };

  return (
    <CustomSwitch
      checked={checked}
      onClick={handleChange}
      icon={
        <span
          style={{
            width: 36,
            height: 36,
            borderRadius: "50%",
            backgroundColor: "white",
            color: typeInfo["vocabulary"].color,
            fontSize: 24,
            fontWeight: "bold",
            textAlign: "center",
          }}
        >
          ?
        </span>
      }
      checkedIcon={
        <span
          style={{
            width: 36,
            height: 36,
            borderRadius: "50%",
            backgroundColor: typeInfo["vocabulary"].color,
            color: "white",
            fontSize: 24,
            fontWeight: "bold",
            textAlign: "center",
          }}
        >
          ?
        </span>
      }
    />
  );
};

export default UnknownSwitch;
